import React from 'react';
var isSub = function isSub(type) {
  return type === 'sub';
};
export default function SubSup(props) {
  if (isSub(props.type)) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/React.createElement("sub", props.dataAttributes, props.children);
  }

  // Ignored via go/ees005
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React.createElement("sup", props.dataAttributes, props.children);
}